import { Wrench, Hammer, LayoutTemplate, TreePine, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Wrench,
    title: "Småreparationer & Handyman-hjælp",
    description:
      "Døre, låse, hylder, små VVS-opgaver og alle de små ting i hjemmet, der bare skal laves ordentligt.",
    details: ["Døre & låse", "Hylder & montering", "Små VVS-opgaver"],
  },
  {
    icon: Hammer,
    title: "Køkken-fornyelse",
    description:
      "Nye låger, bordplader eller total udskiftning af køkken. Finish i topklasse og et resultat du er stolt af at vise frem.",
    details: ["Nye låger", "Bordplader", "Totaludskiftning"],
  },
  {
    icon: LayoutTemplate,
    title: "Lofter & Gulve",
    description:
      "Montering og renovering af lofter og gulve — fra nyt trægulv til akustiklofter udført med præcision.",
    details: ["Nye trægulve", "Loftmontering", "Renovering"],
  },
  {
    icon: TreePine,
    title: "Udearealer",
    description:
      "Træterrasser, skure og specialløsninger til haven. Byggeri der både holder og ser eksklusivt ud år efter år.",
    details: ["Træterrasser", "Skure & carporte", "Specialløsninger"],
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white py-20 md:py-32 bg-craftsman-stripe"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div className="max-w-2xl">
            <div className="eyebrow text-[#1E40AF] mb-4">
              <span className="inline-block w-8 h-[2px] bg-[#1E40AF] align-middle mr-3" />
              01 · Ydelser
            </div>
            <h2
              data-testid="services-heading"
              className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#0F213A] leading-[1.05]"
            >
              Håndværk der dækker{" "}
              <span className="text-[#1E40AF]">hele hjemmet.</span>
            </h2>
          </div>
          <p className="text-[#475569] text-base max-w-md leading-relaxed">
            Én lokal tømrer — fire kerneområder. Jeg hjælper både med den lille
            reparation og det store projekt.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[#E2E8F0] border border-[#E2E8F0]">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.title} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ServiceCard({ service, index }) {
  const Icon = service.icon;
  const num = String(index + 1).padStart(2, "0");
  return (
    <div
      data-testid={`service-card-${index}`}
      className="group relative bg-white p-8 md:p-12 transition-all duration-300 hover:bg-[#0F213A] cursor-default"
    >
      <div className="flex items-start justify-between mb-8">
        <div className="inline-flex items-center justify-center w-14 h-14 border-2 border-[#0F213A] group-hover:border-white group-hover:bg-white transition-colors">
          <Icon
            size={26}
            strokeWidth={2}
            className="text-[#0F213A] group-hover:text-[#0F213A]"
          />
        </div>
        <div className="text-[#E2E8F0] group-hover:text-white/20 text-4xl font-black tracking-tight transition-colors">
          {num}
        </div>
      </div>

      <h3 className="text-xl md:text-2xl font-bold text-[#0F213A] group-hover:text-white transition-colors leading-snug">
        {service.title}
      </h3>
      <p className="mt-4 text-[#475569] group-hover:text-white/75 text-base leading-relaxed transition-colors">
        {service.description}
      </p>

      <ul className="mt-6 flex flex-wrap gap-2">
        {service.details.map((d) => (
          <li
            key={d}
            className="text-[11px] uppercase tracking-[0.15em] font-semibold px-3 py-1.5 border border-[#E2E8F0] text-[#475569] group-hover:border-white/25 group-hover:text-white/80 transition-colors"
          >
            {d}
          </li>
        ))}
      </ul>

      <div className="absolute top-8 right-8 opacity-0 group-hover:opacity-100 transition-opacity">
        <ArrowUpRight className="text-white" size={22} />
      </div>
    </div>
  );
}
